import PropTypes from 'prop-types';
import styled from 'react-emotion';
export var Fill =
/*#__PURE__*/
styled("div", {
  target: "e1168zu30"
})("flex:1;");
Fill.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/spectacle/es/components/fill.js
// module id = 815
// module chunks = 0